import { makeNamespacedComponent } from '@/ui/utils';
import { Card as CardAtoms } from '@/ui/Card';
import { CourseCard as CourseCard_ } from './CourseCard';

export const CourseCard = makeNamespacedComponent(CourseCard_, { Loader: CardAtoms.Loader });
